import * as React from 'react';

import {
  Button,
  type IButtonProps,
  Grid,
  GridColumn,
  Heading,
  Modal,
  type IModalProps,
  Notice,
  INoticeProps,
  Separator,
  Text,
  TextField,
  type ITextFieldProps
} from 'telia-front-react';

export interface IPaymentOptionsModalProps {
  /**
   * Heading text
   */
  headingText: string;
  /**
   * Array of buttons
   */
  buttons: IButtonProps[];
  /**
   * Textfield properties
   */
  textField: ITextFieldProps;
  /**
   * Modal properties
   */
  modal?: IModalProps;
  /**
   * Properties for notice on top of the modal
   */
  notice?: INoticeProps;
}

export default class PaymentOptionsModal extends React.Component<IPaymentOptionsModalProps> {
  render(): JSX.Element {
    const buttons: Array<React.ReactElement<IButtonProps>> = this.props.buttons.map((button: IButtonProps, i: number) => (
      <GridColumn key={i} width={['xs']}>
        <Button {...button} />
      </GridColumn>
    ));

    return (
      <Modal {...this.props.modal}>
        <Text className="text-center">
          <Heading level={1} className="h3">
            {this.props.headingText}
          </Heading>
          {this.props.notice && <Notice {...this.props.notice} />}
          <Separator spacing="small" color="invisible" />
          <Grid align={['center-xs']}>
            <GridColumn width={['lg-4', 'md-6', 'sm-8']}>
              <TextField {...this.props.textField} />
            </GridColumn>
          </Grid>
          <Separator spacing="small" color="invisible" />
          <Grid align={['center-xs']}>
            <GridColumn width={['md-9', 'lg-7', 'xl-6']}>
              <Grid align={['center-xs']}>{buttons}</Grid>
            </GridColumn>
          </Grid>
        </Text>
      </Modal>
    );
  }
}
